import {cn} from "@/lib/utils.ts";

export function Spinner({className}: {className?: string}) {
    return (
        <svg className={cn("os-animate-spin os-brand-text", className)}
             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" width={"48px"} height={"48px"}>
            <path
                  className="os-opacity-25"
                  fill="currentColor"
                  d="M48,24c0,13.3-10.7,24-24,24S0,37.3,0,24,10.7,0,24,0s24,10.7,24,24ZM4.4,24c0,10.8,8.8,19.6,19.6,19.6s19.6-8.8,19.6-19.6S34.8,4.4,24,4.4,4.4,13.2,4.4,24Z"/>
            <path className="cls-1"
                  fill="currentColor"
                  d="M45.1,18.5c1.2-.3,1.9-1.5,1.5-2.6-.8-2.3-2-4.4-3.5-6.3-1.9-2.5-4.3-4.6-7-6.2-2.7-1.6-5.7-2.6-8.9-3.1-2.4-.3-4.8-.3-7.2.1-1.2.2-1.9,1.4-1.6,2.6.3,1.2,1.5,1.8,2.7,1.7,1.8-.3,3.7-.3,5.5,0,2.6.3,5,1.2,7.2,2.5,2.2,1.3,4.2,3,5.7,5.1,1.1,1.5,2,3.1,2.7,4.8.4,1.1,1.6,1.8,2.8,1.5Z"/>
        </svg>
    );
}